import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-2 mb-xl-5" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "fw-bolder m-0 me-3" }
const _hoisted_4 = { class: "button-group d-flex align-items-center" }
const _hoisted_5 = { class: "card-body pl-9 pb-3 px-2" }

import { ref } from "vue";
import IconCaretDown from "@/icons/IconCaretDown.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageRowLayout',
  setup(__props, { expose: __expose }) {

const isExpanded = ref(true);

const toggle = () => {
  isExpanded.value = !isExpanded.value;
}

__expose({ toggle });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "card-title m-0 flex align-items-center cursor-pointer",
        onClick: toggle
      }, [
        _createElementVNode("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "page-row-header")
        ]),
        _createVNode(IconCaretDown, {
          style: _normalizeStyle({ rotate: isExpanded.value ? '180deg' : '' })
        }, null, 8, ["style"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "page-row-action-button")
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "page-row-content")
    ], 512), [
      [_vShow, isExpanded.value]
    ])
  ]))
}
}

})